import { useMemo } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getLiteTradeAccountMetrics } from "../liteTradeSelectors";

function useMarginLevel() {
    const metrics = useSelector(getLiteTradeAccountMetrics);
    const marginLevel = useMemo(() => _.round(metrics?.equity / metrics?.margin * 100, 2), [metrics]);

    return {
        isInited: !!metrics,
        marginLevel,
    }
}

export default useMarginLevel;
